import { useEffect, useState } from "react";
import useArea from "hooks/useArea";
import { useGetVendorsDropdown } from "hooks/useVendors";
import { useEditDeliveryOffer } from "hooks/useDeliveryOffers";
import DeliveryOfferForm from "../DeliveryOfferForm/DeliveryOfferForm";
import { emptyOfferForm, formToBody, offerToForm, validateOfferForm } from "../deliveryOfferModel";

const EditDeliveryOffer = (props) => {
    const { areas } = useArea();
    const { vendors } = useGetVendorsDropdown();
    const editOffer = useEditDeliveryOffer();

    const [form, setForm] = useState(() => emptyOfferForm());
    const change = (patch) => setForm((current) => ({ ...current, ...patch }));

    useEffect(() => {
        if (props.offer) {
            setForm(offerToForm(props.offer));
        }
    }, [props.offer]);

    // The offer keeps its city — restaurants and areas can only be swapped
    // within it. Moving an offer to another city means recreating it.
    const cityId = form.cityId;

    const vendorOptions = cityId
        ? vendors
              .filter((vendor) => +vendor.cityId === +cityId)
              .map((vendor) => ({ value: vendor.id, label: vendor.name }))
        : [];

    const areaOptions = cityId
        ? (areas ?? [])
              .filter((area) => +area.cityId === +cityId)
              .map((area) => ({ value: area.id, label: area.name }))
        : [];

    const submitHandler = async (e) => {
        e.preventDefault();

        const problem = validateOfferForm(form, { needsCity: false });
        if (problem) {
            props.showMessage("error", "هناك خطأ", problem);
            return;
        }

        try {
            await editOffer.mutateAsync({
                id: props.offer.id,
                ...formToBody(form, { withCity: false }),
            });

            props.showMessage("success", "تم التعديل", "تم تعديل العرض بنجاح");
            props.close();
        } catch (err) {
            console.error("Error editing delivery offer:", err);
            props.showMessage(
                "error",
                "هناك خطأ",
                err.response?.data?.message || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <DeliveryOfferForm
            show={props.show}
            close={props.close}
            title="تعديل عرض التوصيل"
            submitLabel="حفظ التعديلات"
            pending={editOffer.isPending}
            form={form}
            onChange={change}
            onSubmit={submitHandler}
            vendorOptions={vendorOptions}
            areaOptions={areaOptions}
        />
    );
};
export default EditDeliveryOffer;
